const generic = {
	fullscreenEnabled: 'fullscreenEnabled',
	fullscreenElement: 'fullscreenElement',
	requestFullscreen: 'requestFullscreen',
	exitFullscreen: 'exitFullscreen',
	fullscreenchange: 'fullscreenchange',
	fullscreenerror: 'fullscreenerror'
} as const;

const webkit = {
	fullscreenEnabled: 'webkitFullscreenEnabled',
	fullscreenElement: 'webkitFullscreenElement',
	requestFullscreen: 'webkitRequestFullscreen',
	exitFullscreen: 'webkitExitFullscreen',
	fullscreenchange: 'webkitfullscreenchange',
	fullscreenerror: 'webkitfullscreenerror'
} as const;

const moz = {
	fullscreenEnabled: 'mozFullScreenEnabled',
	fullscreenElement: 'mozFullScreenElement',
	requestFullscreen: 'mozRequestFullScreen',
	exitFullscreen: 'mozCancelFullScreen',
	fullscreenchange: 'mozfullscreenchange',
	fullscreenerror: 'mozfullscreenerror'
} as const;

const ms = {
	fullscreenEnabled: 'msFullscreenEnabled',
	fullscreenElement: 'msFullscreenElement',
	requestFullscreen: 'msRequestFullscreen',
	exitFullscreen: 'msExitFullscreen',
	fullscreenchange: 'MSFullscreenChange',
	fullscreenerror: 'MSFullscreenError'
} as const;

const documentSafe: Document | Record<string, never> = typeof document !== 'undefined' ? document : {};

const vendor =
	(generic.fullscreenEnabled in documentSafe && generic) ||
	(webkit.fullscreenEnabled in documentSafe && webkit) ||
	(moz.fullscreenEnabled in documentSafe && moz) ||
	(ms.fullscreenEnabled in documentSafe && ms);

function isFullscreenSupported(): boolean {
	if (!documentSafe || !vendor) {
		return false;
	}
	return !!documentSafe[vendor.fullscreenEnabled];
}

const fullscreenElement = () => {
	if (!vendor || !documentSafe) {
		return null;
	}
	return documentSafe[vendor.fullscreenElement];
};

const requestFullscreen = (element: HTMLElement | null) => {
	if (!vendor || !element || !element[vendor.requestFullscreen]) {
		return Promise.reject(new Error('requestFullscreen method not supported'));
	}
	const requestFullscreenMethod = element[vendor.requestFullscreen];

	if (!requestFullscreenMethod) {
		return Promise.reject(new Error('requestFullscreen method not supported'));
	}

	return requestFullscreenMethod.call(element);
};

const exitFullscreen = () => {
	if (!vendor || !documentSafe) {
		return Promise.reject(new Error('exitFullscreen method not supported'));
	}

	const exitFullscreenMethod = documentSafe[vendor.exitFullscreen];

	if (!exitFullscreenMethod) {
		return Promise.reject(new Error('exitFullscreen method not supported'));
	}

	return exitFullscreenMethod.call(documentSafe);
};
const addEventListener = (
	listener: (this: Document, ev: Event) => unknown,
	options?: boolean | AddEventListenerOptions
) => {
	if (!documentSafe || !vendor) {
		return null;
	}

	return documentSafe.addEventListener(vendor.fullscreenchange, listener, options);
};
const removeEventListener = (
	listener: (this: Document, ev: Event) => unknown,
	options?: boolean | EventListenerOptions
) => {
	if (!documentSafe || !vendor) {
		return null;
	}

	return documentSafe.removeEventListener(vendor.fullscreenchange, listener, options);
};

export {
	fullscreenElement,
	requestFullscreen,
	exitFullscreen,
	addEventListener,
	removeEventListener,
	isFullscreenSupported
};
